import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropertyList from "../../../../molecules/PropertyList";
import {
  getCountProperties,
  getPinProperties,
  getPropertiesList,
} from "../../ducks/actions";
import { propertyService } from "../../../../../configs/constants";
import axios from "axios";
import message from "antd/lib/message";
import { Popup, PopupConfirm } from "../../../../atoms/Popup";
import Title from "antd/es/typography/Title";
import CreateProperty from "../../AddProperty/CreateProperty";
import PaymentPlans from "../../AddProperty/PaymentPlans";
import { MenuProps } from "antd";
import CreateParkings from "../../AddParkings/CreateParkings";
import UpdateApprovedRent from "../../UpdateApprovedRent";
import { getMenuItems, listQueryParam, showOption } from "../../utils/utility";
import { SectionHeaderV2 } from "../../../../organism/SectionHeaderV2";
import { searchByOptions as baseSearchByOptions } from "../../constants/searchByOptions";
import { useFeatureToggleSearchByOptions } from "../../../../../hooks/search";
import { usePropertiesSearch } from "../../hooks/usePropertiesSearch";
import { PropertyListQueryParams } from "../../types";

export default () => {
 
  const dispatch:any = useDispatch();
  const [propertyListParams, setPropertyListParams] = useState<PropertyListQueryParams>(listQueryParam);
  const [propertyData, setpropertyData] = useState([]);

  const propertiesCardApi = useSelector(
    (state: any) => state.dashboard.propertiesCard
  );
  const [addSinglePropertyFlag, setSinglePropertyFlag] = useState(false);

  const [visible, setVisible] = useState(false);
  const [trigger, setTrigger] = useState(0);
  const fileData = useSelector((state: any) => state.dashboard.downloadFile);

  const { searchByOptions } = useFeatureToggleSearchByOptions(baseSearchByOptions);
  const { selectOptions, handleSearch, handleChangeSearchBy } = usePropertiesSearch({
    selectedSearchBy: propertyListParams.searchBy,
    setPropertyListParams,
  });

  const MenuItems: MenuProps["items"] = getMenuItems();

  const onDropClick: MenuProps["onClick"] = ({ key }) => {
    setVisible(true);
    setTrigger(+key);
    setSinglePropertyFlag(false);
  };

  const onAdd = () => {
    fetchProperties(); 
  };

  const popup = [
    {
      title: (
        <Title level={3} className="m-0">
          {addSinglePropertyFlag
            ? "Add Single Property Detail"
            : "Upload Properties details through CSV file"}
        </Title>
      ),
      content: (
        <CreateProperty
          onSubmit={onAdd}
          addSinglePropertyFlag={addSinglePropertyFlag}
          setSinglePropertyFlag={setSinglePropertyFlag}
          setVisible={setVisible}
        />
      ),
      width: addSinglePropertyFlag ? 900 : 850,
      style: addSinglePropertyFlag ? { padding: "10px" } : null,
    },
    {
      title: (
        <Title level={3} className="m-0">
          Upload Parkings details through CSV file
        </Title>
      ),
      content: <CreateParkings />,
      width: 650,
    },
    {
      title: (
        <Title level={3} className="m-0">
          {" Upload Payment plans through CSV file"}
        </Title>
      ),
      content: <PaymentPlans onSubmit={onAdd} />,
      width: 850,
    },
    {
      title: (
        <Title level={3} className="m-0">
          Approved rent update through CSV file
        </Title>
      ),
      content: <UpdateApprovedRent onSubmit={onAdd} />,
      width: 850,
    },
  ];

  const popupProps = {
    closable: true,
    visibility: visible,
    title: popup[trigger]?.title,
    content: popup[trigger]?.content,
    width: popup[trigger]?.width,
    style: popup[trigger]?.style,
    onCancel: () => setVisible(false),
  };

  const handleShow = () => {};

  function fetchProperties() {
    dispatch(
      getPropertiesList(
        propertyListParams.searchValue,
        propertyListParams.page,
        propertyListParams.limit,
        true,
        "",
        "",
        true,
        true,
        true,
        propertyListParams.searchBy
      )
    );
  }

  useEffect(() => {
    fileData && setpropertyData(fileData);
  }, [fileData]);

  const onStatus = (id, status) => {
    PopupConfirm({
      title: `Are you sure you want to ${
        status === "disabled" ? "unpublish" : "publish"
      } this property?`,
      content: "This will change the property status",
      onOk: () => onStatusChanged(id, status),
      okText: "Confirm",
    });
  };

  const onStatusChanged = async (id, status) => {
    const url = `${propertyService}/property-landlord/change-property-status/${id}`;
    try {
      const res = await axios.put(url, { property_status: status });
      message.success(res?.data?.message || "Status Updated");
      fetchProperties();
      dispatch(getPinProperties());
      dispatch(getCountProperties());
      dispatch(getPropertiesList(undefined, 1, 10, false, "published", true));
      dispatch(getPropertiesList(undefined, 1, 10, false, "rented", true));
    } catch (e) {
      const { response } = e;
      message.error(response?.data?.message);
    }
  };

  useEffect(() => {
    fetchProperties();
  }, [propertyListParams]);

  // WIP for future
  const onExport = (assetID) => {
    // dispatch(downloadPropertyData(assetID));
  };

  return (
    <>
      <SectionHeaderV2
        heading="Properties"
        total={propertiesCardApi?.totalCount || 0}
        showOption={showOption}
        handleShow={handleShow}
        onSearch={handleSearch}
        onChangeSearchBy={handleChangeSearchBy}
        defaultSearch={propertyListParams.searchValue}
        searchByOptions={searchByOptions}
        selectOptions={selectOptions}
        justifiedItems={true}
        justifyEnd={true}
        searchLabel="Search by property name"
        dropNewAction={onDropClick}
        dropItems={MenuItems}
        dropTrigger={["click"]}
      />

      <PropertyList
        data={propertiesCardApi?.data}
        count={propertiesCardApi?.totalCount}
        type="p"
        pagination={true}
        perPage={propertiesCardApi?.perPage}
        currentPage={propertyListParams.page}
        onpageChange={(e) => setPropertyListParams({ ...propertyListParams, page: e })}
        onStatusChanged={onStatus}
        onExport={onExport}
        propertyData={propertyData}
      />
      <Popup destroyOnClose={true} {...popupProps} />
    </>
  );
};
